export class RetentionPolicyModal {
  private element: HTMLElement;

  constructor(
    private readonly apiBaseUrl: string,
    private readonly onClose: () => void
  ) {
    this.element = document.createElement('div');
    this.element.className = 'modal-backdrop';
  }

  public async mount(container: HTMLElement): Promise<void> {
    this.render();
    container.appendChild(this.element);
    await this.loadPolicy();
  }

  private render(): void {
    this.element.innerHTML = `
      <div class="modal-card" style="max-width: 480px;">
        <div class="modal-header">
          <div style="display:flex; align-items:center; gap:10px;">
            <div style="background:rgba(59,130,246,0.15); border:1px solid rgba(59,130,246,0.4); color:#60a5fa; padding:8px; border-radius:8px;">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
            </div>
            <div>
              <h3 style="font-size:1.1rem; font-weight:700; color:#fff; margin:0;">Retención y Depuración de Video</h3>
              <p style="font-size:0.8rem; color:var(--text-muted); margin:0;">Políticas de almacenamiento forense (NG911 / HIPAA / NOM)</p>
            </div>
          </div>
          <button id="btn-close-retention-modal" class="btn-ghost" style="padding:6px; border-radius:50%;">✕</button>
        </div>

        <form id="form-retention" style="display:flex; flex-direction:column; gap:16px; margin-top:16px;">
          <div class="form-group">
            <label class="form-label" for="inp-retention-days">Tiempo de Almacenamiento (Días)</label>
            <input id="inp-retention-days" class="form-input" type="number" min="1" max="3650" value="90" required />
            <span style="font-size:0.75rem; color:var(--text-muted); margin-top:4px;">
              Los videos con más de esta antigüedad serán purgados automáticamente para optimizar el almacenamiento.
            </span>
          </div>

          <div style="display:flex; align-items:center; justify-content:space-between; background:rgba(255,255,255,0.03); padding:12px; border-radius:8px; border:1px solid var(--border-dim);">
            <div>
              <div style="font-weight:600; font-size:0.85rem; color:#fff;">Depuración Automática Diaria</div>
              <div style="font-size:0.75rem; color:var(--text-muted);">Eliminar videos al alcanzar fecha de expiración</div>
            </div>
            <input type="checkbox" id="chk-auto-purge" checked style="width:18px; height:18px; cursor:pointer;" />
          </div>

          <div id="retention-status-msg" style="display:none; padding:10px; border-radius:8px; font-size:0.85rem;"></div>

          <div style="display:flex; gap:10px; margin-top:8px;">
            <button type="submit" id="btn-save-retention" class="btn-primary" style="flex:1; justify-content:center;">
              GUARDAR POLÍTICA
            </button>
            <button type="button" id="btn-purge-now" class="btn-danger" style="justify-content:center;" title="Ejecutar comprobación y purgar videos vencidos ahora">
              PURGAR AHORA
            </button>
          </div>
        </form>
      </div>
    `;

    this.element.querySelector('#btn-close-retention-modal')?.addEventListener('click', () => {
      this.close();
    });

    const form = this.element.querySelector('#form-retention') as HTMLFormElement;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await this.savePolicy();
    });

    this.element.querySelector('#btn-purge-now')?.addEventListener('click', async () => {
      await this.purgeNow();
    });
  }

  private async loadPolicy(): Promise<void> {
    try {
      const res = await fetch(`${this.apiBaseUrl}/api/v1/media/retention-policy`);
      if (res.ok) {
        const json = await res.json();
        const daysInput = this.element.querySelector('#inp-retention-days') as HTMLInputElement;
        const autoCheck = this.element.querySelector('#chk-auto-purge') as HTMLInputElement;
        if (daysInput && json.data) daysInput.value = String(json.data.retentionDays || 90);
        if (autoCheck && json.data) autoCheck.checked = Boolean(json.data.autoPurgeEnabled);
      }
    } catch (_) {}
  }

  private async savePolicy(): Promise<void> {
    const daysInput = this.element.querySelector('#inp-retention-days') as HTMLInputElement;
    const autoCheck = this.element.querySelector('#chk-auto-purge') as HTMLInputElement;
    const msgBox = this.element.querySelector('#retention-status-msg') as HTMLElement;

    try {
      const res = await fetch(`${this.apiBaseUrl}/api/v1/media/retention-policy`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          retentionDays: parseInt(daysInput.value, 10),
          autoPurgeEnabled: autoCheck.checked
        })
      });

      if (res.ok) {
        msgBox.style.display = 'block';
        msgBox.style.background = 'rgba(16,185,129,0.15)';
        msgBox.style.color = '#34d399';
        msgBox.style.border = '1px solid #10b981';
        msgBox.textContent = 'Política de retención guardada correctamente.';
      }
    } catch (_) {
      msgBox.style.display = 'block';
      msgBox.style.background = 'rgba(239,68,68,0.15)';
      msgBox.style.color = '#f87171';
      msgBox.style.border = '1px solid #ef4444';
      msgBox.textContent = 'Error al comunicarse con el servidor.';
    }
  }

  private async purgeNow(): Promise<void> {
    if (!confirm('¿Desea ejecutar la depuración inmediata de videos que ya hayan superado el tiempo de retención?')) return;
    const msgBox = this.element.querySelector('#retention-status-msg') as HTMLElement;
    try {
      const res = await fetch(`${this.apiBaseUrl}/api/v1/media/retention-policy/purge-now`, { method: 'POST' });
      if (res.ok) {
        const json = await res.json();
        msgBox.style.display = 'block';
        msgBox.style.background = 'rgba(59,130,246,0.15)';
        msgBox.style.color = '#60a5fa';
        msgBox.style.border = '1px solid #3b892f';
        msgBox.textContent = `Purga finalizada: ${json.purgedCount || 0} archivos vencidos eliminados.`;
      }
    } catch (_) {}
  }

  public close(): void {
    this.element.remove();
    this.onClose();
  }
}
